export const RQ_GET_INPUT_DISTRIBUTION_REPORT_API = {
  url: 'inventorystock/doctor-input-report/<%= divisionId %>?fromDate=<%= startDate %>&toDate=<%= endDate %>&inputTypeId=<%= inputTypeId %>&inputNameId=<%= inputNameId %>&doctorNameId=<%= doctorNameId %>&entityTagId=<%= entityTagId %>&doctorUniqueCode=<%= doctorUniqueCode %>',
  method: 'GET',
  auth: true,
};

export const RQ_GET_INPUT_NAME_API = {
  url: 'inventorymaster/input-names-by/<%= locationId %>/<%= inputTypeId %>',
  method: 'GET',
  auth: true,
};

export const RQ_GET_DOCTOR_NAME_API = {
  url: 'inventorymaster/doctor-names-by/<%= locationId %>',
  method: 'GET',
  auth: true,
};
